import { openkit } from "../../library/database";

export const searchCreatives = () => {
  try {
    const resp = openkit.data.find("c_creative");
    return resp;
  } catch (error) {
    console.log(`error`, error);
  }
};
